import { render, staticRenderFns } from "./EditOrNew.vue?vue&type=template&id=4f58c723&"
import script from "./EditOrNew.vue?vue&type=script&lang=js&"
export * from "./EditOrNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports